import splashAnimation from "./assets/lottie/splashAnimation";
/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  // Enable animated to allow Lottie/video instead of the static SVG
  animated: true, // Set to false to use static SVG
  // If your video lives in `src/assets/...` you can require it so the bundler
  // emits a proper URL. Since your file is at `src/assets/video/first_video.mp4`
  // we require it here. Alternatively, place the video in `public/videos/`
  // and set `video` to "/videos/your.mp4".
  useVideo: true,
  video: require("./assets/video/video1.mp4")
};

const greeting = {
  username: "DARE Research Group",
  title: "Davis AI, Robotics, and Edge Research Group",
  subTitle: emoji("🤖⚡University of California, Davis"),
  resumeLink: "https://faculty.engineering.ucdavis.edu/jzhang/", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/ucd-dare",
  // linkedin: "https://www.linkedin.com/in/saadpasta/",
  // gmail: "saadpasta70@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Areas Section

const areasSection = {
  title: "",
  subTitle:
    "Exploring the foundations and applications of intelligent autonomous systems.",
  areas: [
    // emoji("🤖 Robot Learning and Manipulation"),
    // emoji("🧠 Generative Modeling and Diffusion Policies"),
    // emoji("🦾 Reinforcement Learning and World Models"),
    // emoji("🌐 Large Language Models and Agentic AI"),
    // emoji("👁️ Computer Vision and Perception"),
    // emoji("⚙️ Multi-Agent and Cooperative Systems"),
    // emoji("💡 Recommender Systems and Representation Learning"),
    // emoji("📶 Edge Computing and Real-Time Intelligence")
  ],

  researchAreas: [
    {
      areaName: "Agentic AI",
      fontAwesomeClassname: "fas fa-user-astronaut"
    },
    {
      areaName: "Robot Learning",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      areaName: "Reinforcement Learning",
      fontAwesomeClassname: "fas fa-dice-d20"
    },
    {
      areaName: "Generative Models",
      fontAwesomeClassname: "fas fa-wave-square"
    },
    {
      areaName: "LLMs",
      fontAwesomeClassname: "fas fa-language"
    },
    {
      areaName: "Recommender Systems",
      fontAwesomeClassname: "fas fa-thumbs-up"
    },
    {
      areaName: "Edge",
      fontAwesomeClassname: "fas fa-microchip"
    },
    // {
    // areaName: "Multi-Agent",
    //  fontAwesomeClassname: "fas fa-globe"
    // },
    {
      areaName: "Internet of Agents",
      fontAwesomeClassname: "fas fa-network-wired"
    }
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "UC Davis College of Engineering",
      logo: require("./assets/images/stanfordLogo.png"), // Will need to replace with UC Davis logo
      subHeader: "CS",
      duration: "Established 2020 - Present",
      desc: "The DARE Research Group is part of the CS at UC Davis, focusing on cutting-edge research in AI, robotics, and edge computing.",
      descBullets: [
        "Interdisciplinary research spanning computer science, engineering, and robotics",
        "Collaboration with industry partners and government agencies",
        "State-of-the-art facilities and equipment for robotics research"
      ]
    },
    {
      schoolName: "Research",
      logo: require("./assets/images/harvardLogo.png"), // Will need to replace with appropriate icon
      subHeader: "Core Research Focus",
      duration: "Ongoing Research",
      desc: "Our lab conducts research across multiple domains including autonomous systems, machine learning, computer vision, and edge computing.",
      descBullets: [
        "Autonomous robotic systems and navigation",
        "Edge AI and embedded systems",
        "Computer vision and perception",
        "Human-robot interaction"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewAreaBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/areaProgress/areaProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: false, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2018 – Present",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      role: "Front-End Developer",
      company: "Quora",
      companylogo: require("./assets/images/quoraLogo.png"),
      date: "May 2017 – May 2018",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      role: "Software Engineer Intern",
      company: "Airbnb",
      companylogo: require("./assets/images/airbnbLogo.png"),
      date: "Jan 2015 – Sep 2015",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false",
  display: true,
  repos: [
    {id: "CarDreamer", org: "ucd-dare"},
    {id: "VITA", org: "ucd-dare"},
    {id: "EI-Drive", org: "ucd-dare"}
  ]
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "DARE Research Group Featured Projects",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Team Section
const teamSection = {
  title: "DARE Research Group Members",
  subtitle: "Faculty, Students, and Alumni",
  display: true,
  faculty: [
    {
      title: "Dr. Junshan Zhang",
      subtitle: "Professor, UC Davis",
      image: require("./assets/images/team/junshan.png"),
      imageAlt: "Dr. Junshan Zhang",
      advisor: null, // No advisor for faculty
      footerLink: [
        {
          name: "Website",
          url: "https://faculty.engineering.ucdavis.edu/jzhang/"
        },
        {name: "Email", url: "mailto:jazh@ucdavis.edu"}
      ]
    },
    {
      title: "Dr. Zhe Zhao",
      subtitle: "Assistant Professor, UC Davis",
      image: require("./assets/images/team/zhezhao.jpg"),
      imageAlt: "Dr. Zhe Zhao",
      advisor: null,
      footerLink: [
        {name: "Website", url: "https://sites.google.com/view/zhezhao"},
        {name: "Email", url: "mailto:zao@ucdavis.edu"}
      ]
    },
    {
      title: "Dr. Muhao Chen",
      subtitle: "Assistant Professor, UC Davis",
      image: "https://muhaochen.github.io/index_files/mario.jpg",
      imageAlt: "Dr. Muhao Chen",
      advisor: null,
      footerLink: [
        {name: "Website", url: "https://luka-group.github.io/"},
        {name: "Email", url: "mailto:mhchen@ucdavis.edu"}
      ]
    }
  ],
  students: [
    {
      title: "Dechen Gao",
      subtitle: "CS Ph.D. Candidate (2023.04– )",
      image:
        "https://raw.githubusercontent.com/gaodechen/gaodechen.github.io/refs/heads/main/assets/img/prof.jpg",
      imageAlt: "Dechen Gao",
      advisor: "Dr. Junshan Zhang",
      footerLink: [
        {name: "Website", url: "https://gaodechen.github.io/"},
        {name: "Email", url: "mailto:dcgao@ucdavis.edu"}
      ]
    },
    {
      title: "Hanchu Zhou",
      subtitle: "ECE Ph.D. Candidate (2022.09– )",
      image:
        "https://github.com/HanchuZhou/HanchuZhou.github.io/blob/master/assets/img/profile2.jpg?raw=true",
      imageAlt: "Hanchu Zhou",
      advisor: "Dr. Junshan Zhang",
      footerLink: [
        {name: "Website", url: "https://hanchuzhou.github.io/"},
        {name: "Email", url: "mailto:hczhou@ucdavis.edu"}
      ]
    },
    {
      title: "Qiyao Ma",
      subtitle: "CS Ph.D. Student (2025.09– )",
      image:
        "https://raw.githubusercontent.com/Martin-qyma/Martin-qyma.github.io/refs/heads/master/images/graduate.JPG",
      imageAlt: "Qiyao Ma",
      advisor: "Dr. Junshan Zhang",
      footerLink: [
        {name: "Website", url: "https://martin-qyma.github.io/"},
        {name: "Email", url: "mailto:qiyma@ucdavis.edu"}
      ]
    },
    {
      title: "Boqi Zhao",
      subtitle: "CS Ph.D. Student (2025.06– )",
      image:
        "https://raw.githubusercontent.com/Anchor1021/Anchor1021.github.io/refs/heads/main/assets/img/avatar.jpg",
      imageAlt: "Boqi Zhao",
      footerLink: [
        {name: "Website", url: "https://anchor1021.github.io/"},
        {name: "Email", url: "mailto:boqzhao@ucdavis.edu"}
      ]
    },
    {
      title: "Boshi An",
      subtitle: "Visiting (2025.11– ). MS at EPFL",
      image: "https://boshi-an.github.io/images/selfie/photo2.png",
      imageAlt: "Boshi An",
      advisor: "Dr. Junshan Zhang",
      footerLink: [
        {
          name: "Website",
          url: "https://boshi-an.github.io/#section-introduction"
        },
        {name: "Email", url: "mailto:boshi_an@alumni.pku.edu.cn"}
      ]
    },
    // LUKA Lab Current Members (advised by Dr. Muhao Chen)
    {
      title: "Bangzheng Li",
      subtitle: "CS Ph.D. Candidate. Provost's Ph.D. Fellow",
      image: "",
      imageAlt: "Bangzheng Li",
      advisor: "Dr. Muhao Chen",
      footerLink: [
        {name: "Website", url: "https://bangzheng.me/"},
        {
          name: "Google Scholar",
          url: "https://scholar.google.com/citations?user=UcegV-cAAAAJ&hl=en"
        }
      ]
    },
    {
      title: "Rui Cai",
      subtitle: "CS Ph.D. Student (Co-advised with Dr. Zhe Zhao)",
      image: "",
      imageAlt: "Rui Cai",
      advisor: "Dr. Muhao Chen",
      footerLink: []
    },
    {
      title: "Kyle R. Chickering",
      subtitle: "Applied Math Ph.D. Candidate",
      image: "",
      imageAlt: "Kyle R. Chickering",
      advisor: "Dr. Muhao Chen",
      footerLink: [{name: "Website", url: "https://www.math.ucdavis.edu/~krc/"}]
    },
    {
      title: "Dongwon Jung",
      subtitle: "CS Ph.D. Student",
      image:
        "https://jungdongwon.github.io/assets/profile-pics/profile_image.jpeg",
      imageAlt: "Dongwon Jung",
      advisor: "Dr. Muhao Chen",
      footerLink: [{name: "Website", url: "https://jungdongwon.github.io/"}]
    },
    {
      title: "Hadi Askari",
      subtitle: "CS Ph.D. Candidate",
      image: "",
      imageAlt: "Hadi Askari",
      advisor: "Dr. Muhao Chen",
      footerLink: [
        {
          name: "Google Scholar",
          url: "https://scholar.google.com/citations?user=27esPRsAAAAJ&hl=en"
        }
      ]
    },
    {
      title: "James Y. Huang",
      subtitle: "CS Ph.D. Candidate",
      image: "",
      imageAlt: "James Y. Huang",
      advisor: "Dr. Muhao Chen",
      footerLink: [
        {name: "Website", url: "https://jyhuang36.github.io/"},
        {name: "Email", url: "mailto:huangjam@usc.edu"}
      ]
    },
    {
      title: "Yuankai Li",
      subtitle: "CS Ph.D. Student (Incoming Fall 2025). Graduate Fellowship",
      image: "",
      imageAlt: "Yuankai Li",
      advisor: "Dr. Muhao Chen",
      footerLink: []
    },
    {
      title: "Qin Liu",
      subtitle: "CS Ph.D. Candidate. Graduate Fellowship",
      image: "https://qinliu9.github.io/assets/img/profile.jpg",
      imageAlt: "Qin Liu",
      advisor: "Dr. Muhao Chen",
      footerLink: [
        {name: "Website", url: "https://qinliu9.github.io/"},
        {
          name: "Google Scholar",
          url: "https://scholar.google.com/citations?user=dApKnRkAAAAJ&hl=zh-CN"
        }
      ]
    },
    {
      title: "Jacky Mo",
      subtitle: "CS Ph.D. Student (Co-advised with Dr. Zhe Zhao)",
      image: "https://jacky-mo-1111.github.io/assets/img/prof_pic.jpg",
      imageAlt: "Jacky Mo",
      advisor: "Dr. Muhao Chen",
      footerLink: [{name: "Website", url: "https://jacky-mo-1111.github.io/"}]
    },
    {
      title: "Tenghao Huang",
      subtitle: "CS Ph.D. Candidate. Viterbi Ph.D. Fellow",
      image: "",
      imageAlt: "Tenghao Huang",
      advisor: "Dr. Muhao Chen",
      footerLink: [{name: "Website", url: "https://tenghaohuang.github.io/"}]
    },
    {
      title: "Xiaofei Wen",
      subtitle: "CS Ph.D. Student",
      image: "https://rakanwen.github.io/images/Griffith_.jpg",
      imageAlt: "Xiaofei Wen",
      advisor: "Dr. Muhao Chen",
      footerLink: [{name: "Website", url: "https://rakanwen.github.io/"}]
    },
    {
      title: "Tinghui Zhu",
      subtitle: "CS Ph.D. Student (Incoming Fall 2025). Graduate Fellowship",
      image: "https://darthzhu.github.io/assets/img/my_pic.jpg",
      imageAlt: "Tinghui Zhu",
      advisor: "Dr. Muhao Chen",
      footerLink: [{name: "Website", url: "https://darthzhu.github.io/"}]
    }
  ],
  alumni: {
    formerPhd: [
      {
        title: "Hang Wang",
        subtitle:
          "Ph.D, 06/2025. Microsoft. B.S. (Univ. of Science and Technology of China)",
        image: "https://ustcmike.github.io/photos/profile.jpg",
        imageAlt: "Hang Wang",
        advisor: "Dr. Junshan Zhang",
        footerLink: [
          {name: "Website", url: "https://ustcmike.github.io/"},
          {name: "Email", url: "mailto:whang@ucdavis.edu"}
        ]
      },
      {
        title: "Sen Lin",
        subtitle:
          "Ph.D, 10/2021 (co-advised with Lei Ying). Assistant Professor, CS, University of Houston (08/2023–). Postdoc at OSU (07/2022-07/2023). M.S.(Hong Kong Univ. of Science and Technology), B.E.(Zhejiang Univ.)",
        image: "https://slin70.github.io/images/profile.png",
        imageAlt: "Sen Lin",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Zhaofeng Zhang",
        subtitle:
          "Ph.D., 10/2023. Postdoc at ASU (11/2023–). M.S. (Arizona State University)",
        image:
          "https://scholar.googleusercontent.com/citations?view_op=medium_photo&user=4Mfvn6MAAAAJ&citpid=2",
        imageAlt: "Zhaofeng Zhang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Mehmet Dedeoglu",
        subtitle: "Ph.D, 10/2021. Intel. M.S. & B.S.(Bilkent Univ.)",
        image: null,
        imageAlt: "Mehmet Dedeoglu",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Weina Wang",
        subtitle:
          "Ph.D, 05/2016 (co-advised with Lei Ying). Assistant Professor, CS, Carnegie Mellon University (08/2018–). Postdoc at UIUC (08/2016–07/2018). B.E.(Tsinghua Univ.)",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSt5wNvREkHI24Y9MtlJE2mSrxV4n3keu0H-Q&s",
        imageAlt: "Weina Wang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Mojgan Hedayati",
        subtitle:
          "Ph.D., 12/2016 (co-advised with Kory Hedman). ABB. M.S.& B.S.(Sharif Univ. of Technology)",
        image: null,
        imageAlt: "Mojgan Hedayati",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Mengyuan Zhang",
        subtitle:
          "Ph.D. Alibaba. M.S.(Univ. of New South Wales), B.E.(Zhejiang Univ.)",
        image: null,
        imageAlt: "Mengyuan Zhang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "David Ganger",
        subtitle:
          "Ph.D., 07/2016 (co-advised with Vijay Vittal). Schneider Electric - Power Systems Consultant. B.S.(Arizona State Univ.)",
        image: null,
        imageAlt: "David Ganger",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Brian Proulx",
        subtitle:
          "Ph.D., 08/2015. MIT Lincoln Laboratory. M.S.(Univ. of Illinois at Urbana-Champaign), B.S.(Univ. of Notre Dame)",
        image:
          "https://media.licdn.com/dms/image/v2/C5103AQG6Bg41qh_sAw/profile-displayphoto-shrink_200_200/profile-displayphoto-shrink_200_200/0/1516495215625?e=2147483647&v=beta&t=maGzifa4aYNH8T-ztYTtjbycOMyHCTQ3hisSqh2vSFI",
        imageAlt: "Brian Proulx",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Xiaowen Gong",
        subtitle:
          "Ph.D., 05/2015. Associate Professor with ECE at Auburn University (01/2017–). Postdoc at OSU (08/2015–12/2016). M.S.(Univ. of Alberta), B.S.(Huazhong Univ. of Science and Technology)",
        image:
          "https://eng.auburn.edu/images/programs/ece/headshots/gong-xiaowen.jpg",
        imageAlt: "Xiaowen Gong",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Miao He",
        subtitle:
          "Ph.D., 07/2013 (co-advised with Vijay Vittal). Associate Professor with EE at Texas Tech Univ. (08/2013–). M.E.(Tsinghua Univ.), B.E.(Nanjing Univ. of Posts and Telecom.)",
        image: null,
        imageAlt: "Miao He",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Lei Yang",
        subtitle:
          "Ph.D., 11/2012. Associate Professor, CS, University of Nevada, Reno (08/2015–). M.S.& B.S.(Southeast Univ.)",
        image: null,
        imageAlt: "Lei Yang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Dajun Qian",
        subtitle: "Ph.D., 11/2012. Google. M.S.& B.S.(Southeast Univ.)",
        image: null,
        imageAlt: "Dajun Qian",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Shanshan Wang",
        subtitle: "Ph.D., 08/2012. QualComm. M.S.& B.S.(Zhejiang Univ.)",
        image: null,
        imageAlt: "Shanshan Wang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Chandrashekar Theajaswi P.S.",
        subtitle:
          "Ph.D., 01/2011. Samsung Electronics India Software Operations. M.S.(Indian Institute of Science), B.E.(B.M.S. College of Engineering)",
        image: null,
        imageAlt: "Chandrashekar Theajaswi P.S.",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Qinghai Gao",
        subtitle:
          "Ph.D., 11/2008. Amazon. M.S.(Xidian Univ.), B.S.(Xidian Univ.)",
        image: null,
        imageAlt: "Qinghai Gao",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Weiyan Ge",
        subtitle:
          "Ph.D., 09/2008. Apple. M.S.(Chinese Univ. of Hong Kong), B.S.(Peking Univ.)",
        image: null,
        imageAlt: "Weiyan Ge",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Dong Zheng",
        subtitle:
          "Ph.D., 08/2007. Meta. M.S.(Mississippi State Univ.), B.S.(Shanghai Jiaotong Univ.)",
        image: null,
        imageAlt: "Dong Zheng",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Bo Wang",
        subtitle:
          "Ph.D., 08/2006. QualComm. M.S.(Tsinghua Univ.), B.S.(Tsinghua Univ.)",
        image: null,
        imageAlt: "Bo Wang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Ming Hu",
        subtitle:
          "Ph.D., 08/2004. Apple. M.S.(Tsinghua Univ.), B.S.(Tsinghua Univ.)",
        image: null,
        imageAlt: "Ming Hu",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      // LUKA Lab Alumni
      {
        title: "Wenxuan Zhou",
        subtitle: "Ph.D., CS, USC. Research Scientist, Google Deepmind",
        image: "",
        imageAlt: "Wenxuan Zhou",
        advisor: "Dr. Muhao Chen",
        footerLink: [
          {name: "Website", url: "https://wzhouad.github.io/"},
          {
            name: "Google Scholar",
            url: "https://scholar.google.com/citations?user=HHvcwrIAAAAJ&hl=en"
          }
        ]
      },
      {
        title: "Ehsan (Eric) Qasemi",
        subtitle:
          "Ph.D., CS, USC (Co-advised with Pedro Szekely). ML Scientist, Oracle Cloud",
        image: "",
        imageAlt: "Ehsan Qasemi",
        advisor: "Dr. Muhao Chen",
        footerLink: [
          {name: "Website", url: "https://proska.github.io/"},
          {
            name: "Google Scholar",
            url: "http://scholar.google.com/citations?user=2snRpBQAAAAJ&hl=en"
          }
        ]
      },
      {
        title: "Peifeng Wang",
        subtitle:
          "Ph.D., CS, USC (Co-advised with Xiang Ren). Research Scientist, Meta",
        image: "",
        imageAlt: "Peifeng Wang",
        advisor: "Dr. Muhao Chen",
        footerLink: []
      },
      {
        title: "Fei Wang",
        subtitle: "Ph.D., CS, USC. Research Scientist, Google Research",
        image: "",
        imageAlt: "Fei Wang",
        advisor: "Dr. Muhao Chen",
        footerLink: [
          {name: "Website", url: "https://feiwang96.github.io/"},
          {
            name: "Google Scholar",
            url: "https://scholar.google.com/citations?user=N1O2KT8AAAAJ&hl=en"
          }
        ]
      },
      {
        title: "Nan (Nancy) Xu",
        subtitle: "Ph.D., CS, USC. Research Scientist, Google Deepmind",
        image: "",
        imageAlt: "Nan Xu",
        advisor: "Dr. Muhao Chen",
        footerLink: [
          {
            name: "Google Scholar",
            url: "https://scholar.google.com/citations?user=iysoxM4AAAAJ&hl=en"
          }
        ]
      }
    ],
    postdocs: [
      {
        title: "Shusen Jing",
        subtitle: "08/2022–07/2023, jointly with Prof. Zhi Ding",
        image: null,
        imageAlt: "Shusen Jing",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Wei Shao",
        subtitle: "11/2021–05/2023. Research Scientist, CSIRO, Australia",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhnhuJaftmE30f4IjtGT3zsctaPAhRZjUVsQ&s",
        imageAlt: "Wei Shao",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Sen Lin",
        subtitle:
          "10/2021–6/2022. Assistant Professor in CS at University of Houston (08/2023–). Postdoc at OSU (07/2022-07/2023)",
        image: "https://slin70.github.io/images/profile.png",
        imageAlt: "Sen Lin",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Kemi Ding",
        subtitle:
          "09/2018–08/2019. Assistant Professor at Southern Univ of Science and Technology. Ph.D. (Hong Kong Univ. of Science and Technology), B.S.(Huazhong Univ. of Sci. & Tech.)",
        image: null,
        imageAlt: "Kemi Ding",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Xuanyu Cao",
        subtitle:
          "08/2017–06/2019. Assistant Professor at Hongkong Univ of Science and technology (joint postdoc with Prof. H. Vincent Poor at Princeton University). Ph.D. & M.S. (Univ. of Maryland), B.S.(Shanghai Jiao Tong Univ.)",
        image: null,
        imageAlt: "Xuanyu Cao",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Trevor Werho",
        subtitle:
          "07/2016–03/2021. APS. Ph.D.(Arizona State Univ.), B.S.(Arizona State Univ.)",
        image: null,
        imageAlt: "Trevor Werho",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Jun Zhao",
        subtitle:
          "06/2015–03/2017. Assistant Professor at Nangyang Technical Univ. of Singapore, Singapore. Ph.D.(Carnegie Mellon University), B.E.(Shanghai Jiao Tong Univ.)",
        image: null,
        imageAlt: "Jun Zhao",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Xu Chen",
        subtitle:
          "08/2012–02/2014. Professor at Sun Yat-sen University, Guangzhou, China. Ph.D.(Chinese Univ. of Hong Kong), B.S.(South China Univ. of Technology)",
        image: null,
        imageAlt: "Xu Chen",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Donghoon Shin",
        subtitle:
          "08/2012–08/2015. AT&T Labs. Ph.D.(Purdue Univ.), M.S.(Korea Advanced Institute of Science and Technology), B.E.(Korea Univ.)",
        image: null,
        imageAlt: "Donghoon Shin",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Lei Yang",
        subtitle:
          "12/2012–06/2015 (postdoc jointly with Prof. H. Vincent Poor at Princeton). Associate Professor at University of Nevada, Reno. Ph.D.(Arizona State Univ.), M.S.& B.S.(Southeast Univ.)",
        image: null,
        imageAlt: "Lei Yang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Chuan Huang",
        subtitle:
          "08/2012–07/2014. Professor at Chinese University of Hongkong (Shenzhen). Ph.D.(Texas A&M Univ.), M.S.&B.S.(Univ. of Electronic Science and Technology of China)",
        image: null,
        imageAlt: "Chuan Huang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Shibo He",
        subtitle:
          "05/2012–05/2014. Professor at Zhejiang University. Ph.D.(Zhejiang Univ.)",
        image: null,
        imageAlt: "Shibo He",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Sugumar Murugesan",
        subtitle:
          "07/2010–03/2012. Ph.D.& M.S.(The Ohio State Univ.), B.E.(Anna Univ.)",
        image: null,
        imageAlt: "Sugumar Murugesan",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Osman Yagan",
        subtitle:
          "08/2011–12/2011. Research Professor at Carnegie Mellon Univ. Ph.D.(Univ. of Maryland), B.E.(Middle East Technical Univ.)",
        image: null,
        imageAlt: "Osman Yagan",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Chandra Theajaswi P.S.",
        subtitle:
          "02/2011–08/2011. Ph.D.(Arizona State Univ.), M.S.(Indian Institute of Science)",
        image: null,
        imageAlt: "Chandra Theajaswi P.S.",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Eric Kin Wah Kwong",
        subtitle:
          "Ph.D.(Univ. of Pennsylvania), MPhil& BE (Hongkong Univ. of Science and Technology)",
        image: null,
        imageAlt: "Eric Kin Wah Kwong",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Tuan Tran",
        subtitle:
          "05/2010–01/2011. Ph.D.(Oregon State Univ.), M.S.(Politecnico di Torino), M.S.& B.S.(Hanoi Univ. of Technology)",
        image: null,
        imageAlt: "Tuan Tran",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Dong Zheng",
        subtitle:
          "03/2009–12/2009. Meta. Ph.D.(Arizona State Univ.), M.S.(Mississippi State Univ.), B.S.(Shanghai Jiaotong Univ.)",
        image: null,
        imageAlt: "Dong Zheng",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      }
    ],
    formerMasters: [
      {
        title: "Anirban Bhattacharya",
        subtitle: "M.S., 05/2017–05/2018. B.S.(KIIT Univ.). Apple",
        image: null,
        imageAlt: "Anirban Bhattacharya",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Beibei Liu",
        subtitle:
          "M.S., 01/2016–05/2018. B.E.(Univ. of Electronic Science and Technology of China). Ciena Corporation",
        image: null,
        imageAlt: "Beibei Liu",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Jun Chen",
        subtitle:
          "M.S., 08/2014– (co-advised with Lei Ying). B.S.(Univ. of Science and Technology of China)",
        image: null,
        imageAlt: "Jun Chen",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Yangjun Li",
        subtitle: "M.S., 08/2015–08/2018. B.S.(Yanshan Univ.). Amazon AWS",
        image: null,
        imageAlt: "Yangjun Li",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Zhengyu Zhang",
        subtitle: "M.S., 08/2012–12/2015. B.S.(Southeast Univ.)",
        image: null,
        imageAlt: "Zhengyu Zhang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Lian Lu",
        subtitle:
          "M.S., 08/2013–08/2015. M.S.(Chinese Univ. of Hong Kong), B.S.(Tsinghua Univ.)",
        image: null,
        imageAlt: "Lian Lu",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Ashwin Kowdle",
        subtitle: "M.S., 05/2007–11/2008. QualComm",
        image: null,
        imageAlt: "Ashwin Kowdle",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Daniel Aguiar",
        subtitle: "M.S., 01/2005–07/2006",
        image: null,
        imageAlt: "Daniel Aguiar",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Kai Bai",
        subtitle: "M.S., 08/2003–01/2005. Apple",
        image: null,
        imageAlt: "Kai Bai",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Zhifeng Hu",
        subtitle: "M.S., 08/2003–06/2005",
        image: null,
        imageAlt: "Zhifeng Hu",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Eric Lentz",
        subtitle: "M.S., 01/2002–07/2003",
        image: null,
        imageAlt: "Eric Lentz",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Raju",
        subtitle: "M.S., 08/2001–12/2003. Sirf Inc",
        image: null,
        imageAlt: "Raju",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      }
    ],
    visiting: [
      {
        title: "Shuangyu Cai",
        subtitle: "02/2024–. B.S. (Tsinghua University, Yao Class 11)",
        image: null,
        imageAlt: "Shuangyu Cai",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Yiyang Ge",
        subtitle: "05/2025–. B.S. (Zhejiang University)",
        image: null,
        imageAlt: "Yiyang Ge",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Shi Yan",
        subtitle:
          "Visiting Student, 08/2015–. Ph.D. student at Beijing Univ. of Posts and Telecom. B.S.(Beijing Univ. of Posts and Telecom.)",
        image: null,
        imageAlt: "Shi Yan",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Yang Cao",
        subtitle: "08/2011–. B.E.(Huazhong Univ. of Science and Technology)",
        image: null,
        imageAlt: "Yang Cao",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Kai Cai",
        subtitle: "08/2011–07/2012. Ph.D.& M.S.(Peking Univ.)",
        image: null,
        imageAlt: "Kai Cai",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Ling Tang",
        subtitle:
          "Visiting Student, 08/2010–08/2012. Ph.D. student at Southeast Univ. B.S.(Hunan Univ.)",
        image: null,
        imageAlt: "Ling Tang",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Huilan Zou",
        subtitle:
          "Visiting Scholar, 02/2008–02/2009. Central Univ. for Nationalities",
        image: null,
        imageAlt: "Huilan Zou",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      },
      {
        title: "Jia Lou",
        subtitle:
          "Visiting Student, 09/2008–08/2009. Beijing Univ. of Posts and Telecom. Ph.D.(Beijing Univ. of Posts and Telecom.), B.S.(Jilin Univ.)",
        image: null,
        imageAlt: "Jia Lou",
        advisor: "Dr. Junshan Zhang",
        footerLink: []
      }
    ]
  }
};

const blogSection = {
  title: "News",
  subtitle: "DARE News",
  displayMediumBlogs: "false", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://engineering.ucdavis.edu/news/new-dream-platform-promises-make-autonomous-vehicles-safer",
      title: "New 'Dream' Platform Promises to Make Autonomous Vehicles Safer",
      description:
        "An engineering professor at the University of California, Davis, is striving to make autonomous vehicles, or AVs, safer by changing how researchers train them."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "Publications",
  subtitle: emoji("Check out our latest publications 📢"),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Pubs Section
const pubSection = {
  title: "Publications",
  subtitle: emoji("Check out our latest publications 📢"),

  pubs: [
    {
      title: "Vision-to-Action Flow Matching",
      subtitle:
        "Flowing directly from latent images to latent actions via flow matching",
      website_url: "https://ucd-dare.github.io/VITA",
      paper_url: "https://arxiv.org/abs/2507.13231",
      github_url: "https://github.com/ucd-dare/VITA"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Hiring & Contact ☎️"),
  subtitle:
    "We are always looking for talented and motivated students to join DARE!",
  number: "+0-0000000000",
  email_address: "jazh@ucdavis.edu"
};

// Twitter Section

const twitterDetails = {
  userName: "muhao_chen", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  areasSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  teamSection,
  achievementSection,
  blogSection,
  pubSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
